export default "__VITE_ASSET__B9nPr_pM__"